import { useState } from "react";
import Secretarias from "./Types/secretarias";
import TabNavigation from "../../General/TabNavigation";

const Relatorio = () => {
  const [activeTab, setActiveTab] = useState("Secretarias");

  // const tabs = [
  //   {
  //     key: "Secretarias",
  //     label: "Secretarias",
  //     icon: "building",
  //     content: <Secretarias />
  //   }
  // ];

  // return (
  //   <TabNavigation
  //     tabs={tabs}
  //     activeTab={activeTab}
  //     onTabChange={setActiveTab}
  //     variant="default"
  //   />
  // );

  return (
    <Secretarias />
  );
};

export default Relatorio;
